module.exports = __webpack_public_path__ + "static/media/info.eb91d6d3.svg";